module.exports = __webpack_public_path__ + "img/PlatformCustomer.df21e602.png";